import {makeStyles, Theme} from '../../theme'
import {CSSProperties} from '../../types'
import {Color} from './IconButton.types'

const colors = (theme: Theme): Record<`color_${Color}`, CSSProperties> => {
  return {
    color_invert: undefined,
    color_main: undefined,
    color_minor: {
      color: theme.go.schemes.colors.system.TextMinor,
      '&:hover': {
        color: theme.go.schemes.colors.system.TextMain,
      },
    },
  }
}

export const useClasses = makeStyles(
  theme => {
    return Object.assign(colors(theme), {
      loader: {
        width: '1em',
        height: '1em',
      },
    })
  },
  {name: 'IconButton'},
)
